import { render, staticRenderFns } from "./reservationDetails.vue?vue&type=template&id=6b001b6b&scoped=true"
import script from "./reservationDetails.vue?vue&type=script&lang=js"
export * from "./reservationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b001b6b",
  null
  
)

export default component.exports